import React, { Component } from "react";
import {
  Table,
  Popover,
  Popconfirm,
  Spin,
  Tooltip,
  Collapse,
  Empty,
  Select
} from "antd";
import Modal from "react-responsive-modal";
import Deliver from "./../../../assets/Images/icons8-delivery.svg";
import OrderHamb from "./../../../assets/Images/order-hamb.png";
import CancelImg from "./../../../assets/Images/cancel.png";
import OrderInfo from "./../../../assets/Images/order-info.png";
import CardTick from "./../../../assets/Images/card-tick.png";
import Info from "./../../../assets/Images/Info-black.png";
import Pagination from "react-pagination-js";
import "react-pagination-js/dist/styles.css";
import OrderDel from "./../../../assets/Images/order-del.png";
import { NotificationManager } from "react-notifications";
import * as translationHI from "../../../translations/hindi";
import * as translationMA from "../../../translations/marathi";
import InfoIcon from "./../../../assets/Images/info-icon.png";
import CircleCancelImg from "./../../../assets/Images/Circle-cancel.png";
import OrderService from "../../../Services/Orders/OrderService";
import copy from "./../../../assets/Images/copy.png";
import { encryption } from "./../../../helpers/encryption";
import { handleMaskingNumber } from "../../../helpers/maskingNumber";
import LoginService from "../../../Services/Login/LoginService";
import config from "../../../helpers/config";
import { async } from "rxjs";
const { Panel } = Collapse;
const { Option } = Select;
function dragElement(elmnt) {
  var pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else {
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    elmnt.style.top = elmnt.offsetTop - pos2 + "px";
    elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
  }

  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }
}
class ShipmentTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ShipmentGridData: [],
      ShipmentCreatedData: [],
      filterShipmentStatus: false,
      filterShipmentDelivery: false,
      filterShipmentPartner: false,
      orderPopoverOverlay: false,
      ShipmentMdlbtn: false,
      ShipmentLoading: false,
      totalCount: 0,
      currentPage: 1,
      postsPerPage: 10,
      statusFilterData: [],
      DeliveryFilterData: [],
      PartnerFilterData: [],
      strStatus: "",
      strDelivery: "",
      strPartner: "",
      translateLanguage: {},
      ShipmentOrderItem: [],
      ShipmentOrderId: 0,
      shipmentCharges: 0,
      orderId: 0,
      AirwayBillAWBNo: 0,
      AirwayItemIds: 0,
      createdShoppingTabs: false,
      airWayBill2ndTab: false,
      IsStoreDelivery: false,
      createShipmentBtnDisbaled: false,
      orderSearchText: "",
      TemplateData: [],
      selectedTemplate: "0",
      createShipmetLoader: false,
      showShipmentCharge: true,
      ShowSelectCourierPartner: false,
      selectCourierPartner: 0,
      ShipCancelComment: "",
      ShipShowTemplate: false,
      isMobileView: false,
      activePanel: [],
      showNewShipmentCharge: false,
      createShipmentIds: "",
      disabledCheckbox: true,
      ShopItemData: [],
      popUpClicking: false,
      OrdShopId: "",
      ordItemPopupClose: false,
      itemId: 0,
      isNumberMasking: false,
      maskingPrefix: 0,
      maskingSufix: 0,
      tenantMobileMasking: false,
    };
    this.OrderService = new OrderService();
    this.LoginService = new LoginService();
  }

  componentDidMount() {
    this. handleCRMRole();
    this.handleGetShipmentTabGridData();
    this.handleGetShipmentStatusFilterData();
    this.handleGetShipmentDeliveryTypeFilterData();
    this.handleGetShipmentPartnerFilterData();
    if (window.localStorage.getItem("translateLanguage") === "hindi") {
      this.state.translateLanguage = translationHI;
    } else if (window.localStorage.getItem("translateLanguage") === "marathi") {
      this.state.translateLanguage = translationMA;
    } else {
      this.state.translateLanguage = {};
    }
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    if (window.innerWidth <= 1000) {
      this.setState({ isMobileView: true });
    } else {
      this.setState({ isMobileView: false });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
    clearTimeout(this.intervalID);
  }
  /// search data
  handleShipmentSearch = (searchData) => {
    this.setState({
      orderSearchText: searchData,
      currentPage: 1,
    });
    setTimeout(() => {
      this.handleGetShipmentTabGridData();
    }, 5);
  };

  ///-----------------------API function Start--------------------------
   //handle crm role data
   handleCRMRole() {
     
    this.LoginService.Post("/StoreCRMRole/GetStoreRolesByUserID")
      .then((response) => {
        let msg = response.message;
        if (msg === "Success") {
          this.setState({
            isNumberMasking:response.responseData.isNumberMasking,
            maskingPrefix: response.responseData.maskingPrefix,
            maskingSufix: response.responseData.maskingSufix,
            tenantMobileMasking:
            response.responseData.tenantLevelMasking,
            isSuggestionText: response.responseData.suggestionText,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle Get shipment grid data
  handleGetShipmentTabGridData(filter) {
    let self = this;
    this.setState({
      ShipmentLoading: true,
    });
    this.intervalID = setTimeout(
      this.handleGetShipmentTabGridData.bind(this),
      config.pageRefreshTiming
    );
    let inputData = {
      SearchText: this.state.orderSearchText,
      PageNo: this.state.currentPage,
      PageSize: this.state.postsPerPage,
      FilterStatus: this.state.strStatus,
      FilterDelivery: this.state.strDelivery,
      CourierPartner: this.state.strPartner,
    };
    this.OrderService.PostWithData("/HSOrder/GetShipmentDetails", inputData)
      .then((response) => {
        let status = response.message;
        let data = response.responseData;
        if (filter === "filter") {
          if (status === "Success") {
            self.setState({
              ShipmentGridData: data.ordersList,
              totalCount: data.totalCount,
              filterShipmentStatus: false,
              filterShipmentDelivery: false,
              filterShipmentPartner: false,
              ShipmentLoading: false,
            });
          } else {
            self.setState({
              ShipmentGridData: [],
              totalCount: 0,
              filterShipmentStatus: false,
              filterShipmentDelivery: false,
              filterShipmentPartner: false,
              ShipmentLoading: false,
            });
          }
        } else {
          if (status === "Success") {
            self.setState({
              ShipmentGridData: data.ordersList,
              totalCount: data.totalCount,
              ShipmentLoading: false,
            });
          } else {
            self.setState({
              ShipmentGridData: [],
              totalCount: 0,
              ShipmentLoading: false,
            });
          }
        }
      })
      .then((error) => {
        console.log(error);
      });
  }
  /// handle Get Shipment Status filter
  handleGetShipmentStatusFilterData() {
    let self = this;
    let inputParams = {
      pageID: 3,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetOrderStatusFilter",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        let data = response.responseData;
        if (status === "Success") {
          self.setState({
            statusFilterData: data,
          });
        } else {
          self.setState({
            statusFilterData: [],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle Get Delivery Type filter data
  handleGetShipmentDeliveryTypeFilterData() {
    let self = this;
    let inputParams = {
      pageID: 3,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetShoppingBagDeliveryType",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        let data = response.responseData;
        if (status === "Success") {
          self.setState({
            DeliveryFilterData: data,
          });
        } else {
          self.setState({
            DeliveryFilterData: [],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle Get Partner filter data
  handleGetShipmentPartnerFilterData() {
    let self = this;
    let inputParams = {
      pageID: 3,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetCourierPartnerFilter",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        let data = response.responseData;
        if (status === "Success") {
          self.setState({
            PartnerFilterData: data,
          });
        } else {
          self.setState({
            PartnerFilterData: [],
          });
        }
      })
      .then((error) => {
        console.log(error);
      });
  }
  /// handle Update Date and Time
  handleUpdateDateandTime(OrderId) {
    const TranslationContext = this.state.translateLanguage.default;
    let self = this;
    let inputParams = {
      OrderID: OrderId,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/UpdateShipmentPickupPendingData",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        if (status === "Success") {
          NotificationManager.success(
            TranslationContext !== undefined
              ? TranslationContext.alertmessage.success
              : "Success."
          );
          self.handleGetShipmentTabGridData();
        } else {
          NotificationManager.error(
            TranslationContext !== undefined
              ? TranslationContext.alertmessage.failed
              : "Failed."
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle get Order item data by order id
  handleGetOrderItemDataByOrderId(ordId, deliveryTypeName) {
    let self = this;
    if (
      deliveryTypeName === "Store Delivery" ||
      deliveryTypeName === "Pickup"
    ) {
      this.setState({
        selectCourierPartner: "Store",
      });
    } else {
      this.setState({
        selectCourierPartner: "courierpartner",
      });
    }
    let inputParams = {
      orderID: ordId,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetItemDetailByOrderID",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        let data = response.responseData;

        if (status === "Success") {
          self.setState({
            ShipmentOrderItem: data.ordersItems,
            ShipmentOrderId: data.invoiceNumber,
            shipmentCharges: data.shipmentCharges,
            showShipmentCharge: data.isStoreDelivery,
            ShipmentMdlbtn: true,
            airWayBill2ndTab: false,
            orderId: ordId,
            ShowSelectCourierPartner: data.showSelectCourierPartner,
            ShipShowTemplate: data.showTemplate,
            IsStoreDelivery: data.isStoreDelivery,
          });
          if (data.showTemplate) {
            self.handleGetTemplateData();
          }
        } else {
          self.setState({
            ShipmentOrderItem: [],
            ShipmentOrderId: 0,
            shipmentCharges: 0,
            ShipmentMdlbtn: true,
            showShipmentCharge: true,
            airWayBill2ndTab: false,
            orderId: ordId,
            ShowSelectCourierPartner: false,
            ShipShowTemplate: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //To handle the copied button icon
  handleCopiedNumber = (contact_number, item) => {
    let numberValue = encryption(contact_number, "enc");
    window.localStorage.setItem("copiedNumber", numberValue);
    this.setState({
      isNumberCopiedClicked: true,
      isTextCopied: true,
      recentCopiedWBsNo: item.id,
      // copiedTextChatId: copiedTextChatId,
    });
    this.state.isNumberCopiedClicked = true;
    setTimeout(() => {
      this.setState({
        isNumberCopiedClicked: false,
        isTextCopied: false,
      });
    }, 3000);
  };

  /// handle Get Temaplate data
  handleGetTemplateData() {
    let self = this;
    this.OrderService.Post("/HSOrder/GetOrderShippingTemplateName")
      .then((response) => {
        let status = response.message;
        let data = response.responseData;
        if (status === "Success") {
          self.setState({
            TemplateData: data.shippingTemplateList,
          });
        } else {
          self.setState({
            TemplateData: [],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle get AWB Invoice data by order id
  handleGetAWBInvoiceDetailsOrderId(orderId) {
    let self = this;
    let inputParams = {
      orderID: orderId,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetAWBInvoiceDetails",
      inputParams
    )
      .then((response) => {
        let status = response.message;
        let data = response.responseData;

        if (status === "Success") {
          self.setState({
            ShipmentCreatedData: data,
            AirwayBillAWBNo: data[0].awbNumber,
            AirwayItemIds: data[0].itemIDs,
            ShipmentOrderId: data[0].invoiceNo,
            shipmentCharges: data[0].shipmentCharges,
            showShipmentCharge: data[0].isStoreDelivery,
            showNewShipmentCharge: data[0].showShipmentCharges,
            ShipmentMdlbtn: true,
            airWayBill2ndTab: true,
            createdShoppingTabs: true,
            orderId: orderId,
          });
          if (data[0].isStoreDelivery) {
            self.setState({
              IsStoreDelivery: true,
            });
          }
        } else {
          self.setState({
            AirwayBillAWBNo: 0,
            AirwayItemIds: 0,
            ShipmentOrderId: 0,
            shipmentCharges: 0,
            showShipmentCharge: true,
            ShipmentMdlbtn: true,
            orderId: orderId,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// Create Shipment AWB
  handleCreateShipmentAWB() {
    let self = this;
    var itemIds = "";
    if (this.state.ShipmentOrderItem.length > 0) {
      for (let i = 0; i < this.state.ShipmentOrderItem.length; i++) {
        if (this.state.ShipmentOrderItem[i].checked && !this.state.disable)
          itemIds += this.state.ShipmentOrderItem[i].id + ",";
      }
    }
    this.setState({
      createShipmentBtnDisbaled: true,
      createShipmetLoader: true,
    });
    let inputParams = {
      orderID: this.state.orderId,
      itemIDs: itemIds,
      templateID: this.state.ShipShowTemplate ? this.state.selectedTemplate : 0,
    };
    this.OrderService.PostWithParams("/HSOrder/CreateShipmentAWB", inputParams)
      .then((response) => {
        let CheckStatus = response.status;
        let data = response.responseData;
        if (CheckStatus) {
          if (data.status) {
            var tempShipmentCreatedData = [];
            tempShipmentCreatedData.push(data);
            self.setState({
              ShipmentCreatedData: tempShipmentCreatedData,
              AirwayBillAWBNo: data.awbNumber,
              AirwayItemIds: data.itemIDs,
              createdShoppingTabs: true,
              createShipmentBtnDisbaled: false,
              createShipmetLoader: false,
            });
            if (data.isStoreDelivery) {
              self.setState({
                IsStoreDelivery: true,
              });
            }
          } else {
            NotificationManager.error(data.statusMessge);
            self.setState({
              ShipmentMdlbtn: false,
            });
          }
          self.handleGetShipmentTabGridData();
        } else {
          NotificationManager.error(response.message);
          self.setState({
            createdShoppingTabs: false,
            createShipmentBtnDisbaled: false,
            createShipmetLoader: false,
            ShipmentMdlbtn: false,
          });
        }
      })
      .catch((error) => {
        self.setState({ createShipmetLoader: false });
        console.log(error);
      });
  }
  /// make shipment Store delivery
  handleMakeShipmentAsStoreDelivery() {
    let self = this;

    var itemIds = "";
    if (this.state.ShipmentOrderItem.length > 0) {
      for (let i = 0; i < this.state.ShipmentOrderItem.length; i++) {
        if (this.state.ShipmentOrderItem[i].checked && !this.state.disable)
          itemIds += this.state.ShipmentOrderItem[i].id + ",";
      }
    }
    // var checkboxes = document.getElementsByName("CreateShipment");

    // for (var i in checkboxes) {
    //   if (isNaN(i) === false) {
    //     if (checkboxes[i].checked === true) {
    //       if (checkboxes[i].getAttribute("attrIds") !== null)
    //         itemIds += checkboxes[i].getAttribute("attrIds") + ",";
    //     }
    //   }
    // }
    this.setState({
      createShipmentBtnDisbaled: true,
      createShipmetLoader: true,
    });
    let inputParams = {
      orderID: this.state.orderId,
      itemIDs: itemIds,
      templateID: this.state.ShipShowTemplate ? this.state.selectedTemplate : 0,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/MakeShipmentAsStoreDelivery",
      inputParams
    )
      .then((response) => {
        let CheckStatus = response.status;
        let data = response.responseData;
        if (CheckStatus) {
          if (data.status) {
            var tempShipmentCreatedData = [];
            tempShipmentCreatedData.push(data);
            self.setState({
              ShipmentCreatedData: tempShipmentCreatedData,
              AirwayBillAWBNo: data.awbNumber,
              AirwayItemIds: data.itemIDs,
              createdShoppingTabs: true,
              createShipmentBtnDisbaled: false,
              createShipmetLoader: false,
            });
            if (data.isStoreDelivery) {
              self.setState({
                IsStoreDelivery: true,
              });
            }
          } else {
            NotificationManager.error(data.statusMessge);
            self.setState({
              ShipmentMdlbtn: false,
              createShipmetLoader: false,
            });
          }
          self.handleGetShipmentTabGridData();
        } else {
          NotificationManager.error(response.message);
          self.setState({
            createdShoppingTabs: false,
            createShipmentBtnDisbaled: false,
            createShipmetLoader: false,
            ShipmentMdlbtn: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /// handle cancel and comment for Shopping bag
  handleCancleAndCommnetShipment(OrdId) {
    const TranslationContext = this.state.translateLanguage.default;
    let self = this;
    if (this.state.ShipCancelComment !== "") {
      let inputData = {
        orderID: OrdId,
        cancellationReason: this.state.ShipCancelComment,
      };
      this.OrderService.PostWithData("/HSOrder/CancelOrder", inputData)
        .then((response) => {
          let status = response.message;
          if (status === "Success") {
            self.setState({
              ShipCancelComment: "",
            });
            NotificationManager.success(
              TranslationContext !== undefined
                ? TranslationContext.alertmessage.success
                : "Success."
            );
          } else {
            NotificationManager.error(
              TranslationContext !== undefined
                ? TranslationContext.alertmessage.failed
                : "Failed."
            );
          }
          self.handleGetShipmentTabGridData();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      NotificationManager.error(
        TranslationContext !== undefined
          ? TranslationContext.alertmessage.pleaseentercomment
          : "Please Enter Comment."
      );
    }
  }
  ///-----------------------API function End----------------------------
  handleCreateShipmentCheck() {
    const TranslationContext = this.state.translateLanguage.default;
    if (this.state.ShowSelectCourierPartner) {
      if (
        this.state.selectCourierPartner !== "0" &&
        this.state.selectCourierPartner !== 0
      ) {
        if (this.state.selectCourierPartner === "Store") {
          this.handleCheckShowTemplateData();
        } else if (
          this.state.selectCourierPartner !== "Store" &&
          this.state.IsStoreDelivery
        ) {
          this.handleCheckShowTemplateData();
        } else {
          this.handleCheckShipmentAWB();
        }
      } else {
        NotificationManager.error(
          TranslationContext !== undefined
            ? TranslationContext.ticketingDashboard.pleaseselectcourierpartner
            : "Please Select Courier Partner."
        );
      }
    } else {
      if (this.state.IsStoreDelivery && !this.state.ShowSelectCourierPartner) {
        NotificationManager.error(
          TranslationContext !== undefined
            ? TranslationContext.ticketingDashboard.pleaseselectcourierpartner
            : "Please Enable Store As a Delivery Partner"
        );
      } else {
        this.handleCheckShipmentAWB();
      }
    }
  }
  /// handle check template data api function
  handleCheckShowTemplateData() {
    const TranslationContext = this.state.translateLanguage.default;
    if (this.state.ShipShowTemplate) {
      if (this.state.selectedTemplate !== "0") {
        this.handleMakeShipmentAsStoreDelivery();
      } else {
        NotificationManager.error(
          TranslationContext !== undefined
            ? TranslationContext.ticketingDashboard.pleaseselecttemplate
            : "Please Select Template."
        );
      }
    } else {
      this.handleMakeShipmentAsStoreDelivery();
    }
  }
  /// handle check AWB data api function
  handleCheckShipmentAWB() {
    const TranslationContext = this.state.translateLanguage.default;
    if (this.state.ShipShowTemplate) {
      if (this.state.selectedTemplate !== "0") {
        this.handleCreateShipmentAWB();
      } else {
        NotificationManager.error(
          TranslationContext !== undefined
            ? TranslationContext.ticketingDashboard.pleaseselecttemplate
            : "Please Select Template."
        );
      }
    } else {
      this.handleCreateShipmentAWB();
    }
  }

  //// shipment Modale Close
  handleShipmentModalClose(e) {
    e.stopPropagation();
    this.setState({
      ShipmentMdlbtn: false,
      createdShoppingTabs: false,
      airWayBill2ndTab: false,
      createShipmetLoader: false,
      ShipmentOrderItem: [],
      selectedTemplate: "0",
      createShipmentBtnDisbaled: false,
    });
  }
  /// handle check partner status
  handleCheckPartnerOnchange() {
    var checkboxes = document.getElementsByName("ShipmentPartner");
    var strPartner = "";
    for (var i in checkboxes) {
      if (isNaN(i) === false) {
        if (checkboxes[i].checked === true) {
          if (checkboxes[i].getAttribute("attrIds") !== null)
            strPartner += checkboxes[i].getAttribute("attrIds") + ",";
        }
      }
    }
    this.setState({
      strPartner,
      currentPage: 1,
    });
  }

  /// handle check create shipment
  // handleCheckCreateShipment() {
  //
  //   this.setState({
  //     createShipmentIds:""
  //   });
  //   var checkboxes = document.getElementsByName("CreateShipment");
  //   var strStatus = "";
  //   for (var i in checkboxes) {
  //     if (isNaN(i) === false) {
  //       if (checkboxes[i].checked === true) {
  //         if (checkboxes[i].getAttribute("attrIds") !== null)
  //           strStatus += checkboxes[i].getAttribute("attrIds") + ",";
  //       }
  //     }
  //   }
  //   this.setState({
  //     createShipmentIds:strStatus
  //   });
  // }

  handleCheckArticleNo(id) {
    // if (!this.state.disabledCheckbox) {
    var ShipmentOrderItem = this.state.ShipmentOrderItem;
    for (var i = 0; i < ShipmentOrderItem.length; i++) {
      if (ShipmentOrderItem[i].id === id) {
        if (ShipmentOrderItem[i].disable == 0)
          ShipmentOrderItem[i].checked = !ShipmentOrderItem[i].checked;
      }
    }
    this.setState({
      ShipmentOrderItem,
    });
    // }
  }
  /// handle check individual status
  handleCheckDeliIndividualStatus() {
    var checkboxes = document.getElementsByName("ShipmentStatus");
    var strStatus = "";
    for (var i in checkboxes) {
      if (isNaN(i) === false) {
        if (checkboxes[i].checked === true) {
          if (checkboxes[i].getAttribute("attrIds") !== null)
            strStatus += checkboxes[i].getAttribute("attrIds") + ",";
        }
      }
    }
    this.setState({
      strStatus,
      currentPage: 1,
    });
  }
  /// handle Devilery filter change
  handleCheckDeliveryOnchange() {
    var checkboxes = document.getElementsByName("ShipmentDelivery");
    var strDelivery = "";
    for (var i in checkboxes) {
      if (isNaN(i) === false) {
        if (checkboxes[i].checked === true) {
          if (checkboxes[i].getAttribute("attrIds") !== null)
            strDelivery += checkboxes[i].getAttribute("attrIds") + ",";
        }
      }
    }
    this.setState({
      strDelivery,
      currentPage: 1,
    });
  }
  ///handle pagination onchage
  PaginationOnChange = async (numPage) => {
    await this.setState({
      currentPage: numPage,
    });

    this.handleGetShipmentTabGridData();
  };
  /// handle per page item change
  handlePageItemchange = async (e) => {
    await this.setState({
      postsPerPage: e,
      currentPage: 1,
    });

    this.handleGetShipmentTabGridData();
  };
  /// handle Close Partner filter
  handleClosePartnerFilter() {
    this.setState({
      filterShipmentPartner: false,
    });
  }
  /// handle close Delievry filter
  handleCloseDeliveryFilter() {
    this.setState({
      filterShipmentDelivery: false,
    });
  }
  /// handle close status filter
  handleCloseStatusFilter() {
    this.setState({
      filterShipmentStatus: false,
    });
  }
  /// handle select template data
  handleSelectTemplateDD  = (e)=> {
    this.setState({
      selectedTemplate: e.target.value,
    });
    console.log(e,"Tempalte")
    console.log(this.state.selectedTemplate,"Tempalte")
  };
  handlecollapseChange = (e) => {
    this.state.activePanel = e[e.length - 1];
    this.setState({ activePanel: this.state.activePanel });
  };
  /// handle check order item data with item id
  handleCheckOrderItemData(itemId) {
    if (this.state.ShopItemData.length > 0) {
      var ordItem = this.state.ShopItemData.filter((x) => x.skuId === itemId);
      if (ordItem.length === 0) {
        setTimeout(() => {
          this.handleOrdItemOpen(itemId);
        }, 50);
      } else {
        document.getElementById(
          "ord" + itemId + this.state.OrdShopId + "Itm"
        ).style.display = "block";
        dragElement(
          document.getElementById("ord" + itemId + this.state.OrdShopId + "Itm")
        );
      }
    } else {
      setTimeout(() => {
        this.handleOrdItemOpen(itemId);
      }, 50);
    }
  }
  /// handle get itam data
  handleOrdItemOpen(itemId) {
    let self = this;
    self.setState({
      popUpClicking: true,
    });
    let inputParams = {
      StoreCode: this.state.OrdStoreCode,
      SKUItemCodes: itemId,
    };
    this.OrderService.PostWithParams(
      "/HSOrder/GetItemDetailsBySKU",
      inputParams
    )
      .then((response) => {
        var status = response.message;
        var data = response.responseData.data;
        if (status === "Success" && data.length > 0) {
          var OrdData = self.state.ShopItemData;
          OrdData.push(data[0]);
          self.setState({
            ShopItemData: OrdData,
            popUpClicking: false,
          });
          document.getElementById(
            "ord" + itemId + self.state.OrdShopId + "Itm"
          ).style.display = "block";
          dragElement(
            document.getElementById(
              "ord" + itemId + self.state.OrdShopId + "Itm"
            )
          );
        } else {
          NotificationManager.error("Record not found.");
          self.setState({
            popUpClicking: false,
          });
        }
      })
      .catch((error) => {
        self.setState({
          popUpClicking: false,
        });
        console.log(error);
      });
  }
  /// handle close all item pop modal
  handleCloseAllItemPop() {
    this.setState({
      orderPopoverOverlay: false,
      ordItemPopupClose: false,
      ShopItemData: [],
      OrdShopId: "",
      popUpClicking: false,
    });
  }
  /// handle close item pop modal
  handleCloseItemPop(itemId) {
    document.getElementById(
      "ord" + itemId + this.state.OrdShopId + "Itm"
    ).style.display = "none";
    this.setState({
      popUpClicking: false,
    });
  }
  handleStoreOrderItemData(OrderData) {
    this.setState({
      ShopItemData: [],
      OrdStoreCode: OrderData.storeCode,
      ordItemPopupClose: true,
      OrdShopId: OrderData.shoppingBagNo,
      itemId: OrderData.id,
    });
  }
  render() {
    const TranslationContext = this.state.translateLanguage.default;
    return (
      <>
        {this.state.orderPopoverOverlay && (
          <div className="order-popover-overlay"></div>
        )}
        <div className="table-cntr store dv-table-paging shipmo">
          <p className="shopi">
            {TranslationContext !== undefined
              ? TranslationContext.label.shipment
              : "Shipment"}
          </p>
          {!this.state.isMobileView ? (
            <Table
              className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table antd-table-order-mobile"
              columns={[
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.label.orderid
                      : "Order ID",
                  key: "invoiceNo",
                  render: (row, item) => {
                    return (
                      <div className="d-flex align-items-center overflow-hidden namenumbermain">
                        <Tooltip title={item.invoiceNo} placement="bottom">
                          <p className="order-bill-no">
                            {item.invoiceNo.length > 13
                              ? item.invoiceNo.substr(0, 13).concat("...")
                              : item.invoiceNo}
                          </p>
                        </Tooltip>
                        {item.isShoppingBagConverted === true && (
                          <Popover
                            content={
                              <>
                                <p className="shopping-num-invoice">
                                  Ref. No :<span>{item.shoppingBagNo}</span>
                                </p>
                                {/* <Table
                                  className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table"
                                  columns={[
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemid
                                          : "Item ID",
                                      dataIndex: "itemID",
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemname
                                          : "Item Name",
                                      dataIndex: "itemName",
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemprice
                                          : "Item Price",
                                      dataIndex: "itemPrice",
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.quantity
                                          : "Quantity",
                                      dataIndex: "quantity",
                                    },
                                  ]}
                                  scroll={{ y: 240 }}
                                  pagination={false}
                                  dataSource={
                                    item.shoppingBagItemList.length > 0
                                      ? item.shoppingBagItemList
                                      : []
                                  }
                                /> */}
                              </>
                            }
                            trigger="click"
                            overlayClassName="shipment-i-icon order-popover-table order-popover order-popover-invoice"
                            placement="bottomLeft"
                            onVisibleChange={(visible) =>
                              this.setState({ orderPopoverOverlay: visible })
                            }
                          >
                            <img
                              src={OrderInfo}
                              className="order-info"
                              alt="OrderInfo"
                            />
                          </Popover>
                        )}
                        <div className="namenumber">
                          <p>{item.customerName},</p>
                          <p className="order-small-font">
                            {item.mobileNumber}
                          </p>
                        </div>
                      </div>
                    );
                  },
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.date
                      : "Date",
                  render: (row, item) => {
                    return (
                      <div>
                        <p>{item.date}</p>
                        <p className="order-small-font">{item.time}</p>
                      </div>
                    );
                  },
                  className: "order-desktop table-coloum-hide",
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.customer
                      : "Customer",
                  className: "table-coloum-hide",
                  render: (row, item) => {
                    return (
                      <div>
                        <p>{item.customerName},</p>
                        <div className="text_copied_div">
                          <p className="order-small-font">
                            {/* {item.mobileNumber} */}
                            {this.state.isNumberMasking === true &&
                            this.state.tenantMobileMasking === true ? (
                              <p className="num">
                                {handleMaskingNumber(
                                  item.mobileNumber,
                                  this.state.maskingPrefix,
                                  this.state.maskingSufix
                                )}
                              </p>
                            ) : (
                              <p className="num stop_copying">
                                {item.mobileNumber}
                              </p>
                            )}
                          </p>
                          {this.state.isNumberMasking === true &&
                          this.state.tenantMobileMasking === true ? (
                            <p>
                              <img
                                className="imgsz"
                                src={copy}
                                onClick={(e) =>
                                  this.handleCopiedNumber(
                                    item.mobileNumber,
                                    item
                                  )
                                }
                                // onClick={() => {navigator.clipboard.writeText(item.customerName)}}
                              />
                            </p>
                          ) : null}
                          {this.state.isTextCopied &&
                          this.state.recentCopiedWBsNo == item.id ? (
                            <label className="text_copied"> Copied </label>
                          ) : null}
                        </div>
                      </div>
                    );
                  },
                },

                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.items
                      : "Items",
                  render: (row, item) => {
                    return (
                      <div className="d-flex align-items-center">
                        <p>{item.ordersItemList.length}</p>
                        <Popover
                          content={
                            <>
                              <img
                                src={CircleCancelImg}
                                alt="Cancel"
                                className="ordcnclimg"
                                onClick={this.handleCloseAllItemPop.bind(
                                  this,
                                  item.invoiceNo
                                )}
                              />
                              <Table
                                className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table"
                                columns={[
                                  {
                                    title:
                                      TranslationContext !== undefined
                                        ? TranslationContext.title.itemid
                                        : "Item ID",
                                    dataIndex: "itemID",
                                  },
                                  {
                                    title:
                                      TranslationContext !== undefined
                                        ? TranslationContext.title.itemname
                                        : "Item Name",
                                    dataIndex: "itemName",
                                    width: 150,
                                  },
                                  {
                                    title:
                                      TranslationContext !== undefined
                                        ? TranslationContext.title.itemprice
                                        : "Item Price",
                                    dataIndex: "itemPrice",
                                  },
                                  {
                                    title:
                                      TranslationContext !== undefined
                                        ? TranslationContext.title.quantity
                                        : "Quantity",
                                    dataIndex: "quantity",
                                  },
                                  {
                                    title:
                                      TranslationContext !== undefined
                                        ? TranslationContext.title.properties
                                        : "Properties",
                                    className: item.showItemProperty
                                      ? "order-desktop"
                                      : "ordItmDis",
                                    render: (row, item) => {
                                      return (
                                        <>
                                          {item.showItemProperty &&
                                          item.itemName.toLowerCase() !==
                                            "delivery charge" ? (
                                            <div className="d-flex align-items-center">
                                              <img
                                                src={InfoIcon}
                                                alt="Info"
                                                className={
                                                  this.state.popUpClicking
                                                    ? "disabled-link info-icon"
                                                    : "info-icon"
                                                }
                                                onClick={this.handleCheckOrderItemData.bind(
                                                  this,
                                                  item.itemID
                                                )}
                                              />
                                            </div>
                                          ) : null}
                                        </>
                                      );
                                    },
                                  },
                                ]}
                                scroll={{ y: 240 }}
                                pagination={false}
                                dataSource={item.ordersItemList}
                              />
                              {this.state.ShopItemData
                                ? this.state.ShopItemData.map((data, i) => (
                                    <div
                                      id={
                                        "ord" +
                                        data.skuId +
                                        this.state.OrdShopId +
                                        "Itm"
                                      }
                                      className="ordItmData itmDb"
                                      key={i}
                                    >
                                      <img
                                        src={CircleCancelImg}
                                        alt="Cancel"
                                        className="ordcnclimg"
                                        onClick={this.handleCloseItemPop.bind(
                                          this,
                                          data.skuId
                                        )}
                                      />
                                      <table>
                                        <thead className="ordItheader">
                                          <tr>
                                            <th>Item Id</th>
                                            <th>Color</th>
                                            <th>Size</th>
                                            <th>Image</th>
                                            <th>Image Url</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.ShopItemData !== null &&
                                            this.state.ShopItemData.filter(
                                              (x) => x.skuId === data.skuId
                                            ).map((item, o) => (
                                              <tr key={o}>
                                                <td>
                                                  <label className="skuIdLbl">
                                                    {item.skuId}
                                                  </label>
                                                </td>
                                                <td>{item.colour}</td>
                                                <td>{item.size}</td>
                                                <td>
                                                  <img
                                                    src={item.defaultImageUrl}
                                                    alt="Item"
                                                    className="itemOrdImg"
                                                  />
                                                </td>
                                                <td>
                                                  <a
                                                    href={item.defaultImageUrl}
                                                    target="_blank"
                                                  >
                                                    {TranslationContext !==
                                                    undefined
                                                      ? TranslationContext
                                                          .ticketingDashboard
                                                          .clicktodownload
                                                      : "Click to view"}
                                                  </a>
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ))
                                : null}
                            </>
                          }
                          trigger="click"
                          overlayClassName={
                            this.state.ordItemPopupClose
                              ? "order-popover-table order-popover shopping-bag-popover-item order-popover-table-big"
                              : "order-popover-table order-popover shopping-bag-popover-item order-popover-table-big OrdItem"
                          }
                          onVisibleChange={(visible) =>
                            this.setState({ orderPopoverOverlay: visible })
                          }
                        >
                          <img
                            src={OrderHamb}
                            className="order-hamb"
                            onClick={this.handleStoreOrderItemData.bind(
                              this,
                              item
                            )}
                          />
                        </Popover>
                      </div>
                    );
                  },
                  width: 100,
                  className: "order-desktop",
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.shippingaddress
                      : "Shipping address",
                  render: (row, item) => {
                    return (
                      <p className="order-small-font">{item.shippingAddress}</p>
                    );
                  },
                  width: 250,
                  className: "white-space-init table-coloum-hide",
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.deliverytype
                      : "Delivery Type",
                  className:
                    "shopping-delivery-header camp-status-header camp-status-header-statusFilter table-coloum-hide order-status-header",
                  dataIndex: "deliveryTypeName",
                  width: 150,
                  filterDropdown: (data, row) => {
                    return (
                      <div className="campaign-status-drpdwn">
                        <ul>
                          {this.state.DeliveryFilterData !== null &&
                            this.state.DeliveryFilterData.map((item, b) => (
                              <li key={b}>
                                <input
                                  type="checkbox"
                                  id={"New" + item.deliveryTypeID}
                                  className="ch1"
                                  onChange={this.handleCheckDeliveryOnchange.bind(
                                    this
                                  )}
                                  name="ShipmentDelivery"
                                  attrIds={item.deliveryTypeID}
                                />
                                <label htmlFor={"New" + item.deliveryTypeID}>
                                  <span className="ch1-text">
                                    {item.deliveryTypeName}
                                  </span>
                                </label>
                              </li>
                            ))}
                        </ul>
                        <div className="dv-status">
                          <button
                            className="btn-apply-status"
                            onClick={this.handleGetShipmentTabGridData.bind(
                              this,
                              "filter"
                            )}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.apply
                              : "Apply"}
                          </button>
                          <button
                            className="btn-cancel-status"
                            onClick={this.handleCloseDeliveryFilter.bind(this)}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.cancel
                              : "Cancel"}
                          </button>
                        </div>
                      </div>
                    );
                  },
                  filterDropdownVisible: this.state.filterShipmentDelivery,
                  onFilterDropdownVisibleChange: (visible) =>
                    this.setState({ filterShipmentDelivery: visible }),
                  filterIcon: (filtered) => (
                    <span
                      style={{ color: filtered ? "#1890ff" : undefined }}
                    ></span>
                  ),
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.tender
                      : "Payment Mode",
                  render: (row, item) => {
                    return <p className="order-small-font">{item.tender}</p>;
                  },
                  width: 150,
                  className: "white-space-init table-coloum-hide",
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.status
                      : "Status",
                  className:
                    "camp-status-header camp-status-header-statusFilter table-coloum-hide order-status-header",
                  render: (row, item) => {
                    return (
                      <div className="d-flex align-items-center">
                        <p>{item.statusName}</p>
                        <Popover
                          content={
                            <div className="order-tab-popover shipment-status-popover">
                              <div className="d-flex align-items-center justify-content-between">
                                <p>
                                  {TranslationContext !== undefined
                                    ? TranslationContext.ticketingDashboard
                                        .expectedpickupdate
                                    : "Expected Pickup Date"}
                                  :
                                </p>
                                <p className="username-mar">
                                  {item.pickupScheduledDate}
                                </p>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>
                                  {TranslationContext !== undefined
                                    ? TranslationContext.ticketingDashboard
                                        .expecteddeliverydate
                                    : "Expected Delivery Date"}
                                  :
                                </p>
                                <p className="username-mar">
                                  {item.estimatedDeliveryDate}
                                </p>
                              </div>
                              {item.showShipmentCharges ? (
                                <div className="d-flex align-items-center justify-content-between">
                                  <p>
                                    {TranslationContext !== undefined
                                      ? TranslationContext.ticketingDashboard
                                          .charges
                                      : "Charges"}
                                    :
                                  </p>
                                  <p className="username-mar">
                                    {item.shippingCharges}
                                  </p>
                                </div>
                              ) : null}
                            </div>
                          }
                          trigger="click"
                          overlayClassName="order-popover shopping-popover-cancel"
                          onVisibleChange={(visible) =>
                            this.setState({ orderPopoverOverlay: visible })
                          }
                        >
                          {item.courierPartner !== "" &&
                          item.courierPartner !== "Store" ? (
                            <img src={OrderInfo} className="order-info" />
                          ) : null}
                        </Popover>
                      </div>
                    );
                  },
                  filterDropdown: (data, row) => {
                    return (
                      <div className="campaign-status-drpdwn">
                        <ul>
                          {this.state.statusFilterData !== null &&
                            this.state.statusFilterData.map((item, b) => (
                              <li key={b}>
                                <input
                                  type="checkbox"
                                  id={"New" + item.statusID}
                                  className="ch1"
                                  onChange={this.handleCheckDeliIndividualStatus.bind(
                                    this
                                  )}
                                  name="ShipmentStatus"
                                  attrIds={item.statusID}
                                />
                                <label htmlFor={"New" + item.statusID}>
                                  <span className="ch1-text">
                                    {item.statusName}
                                  </span>
                                </label>
                              </li>
                            ))}
                        </ul>
                        <div className="dv-status">
                          <button
                            className="btn-apply-status"
                            onClick={this.handleGetShipmentTabGridData.bind(
                              this,
                              "filter"
                            )}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.apply
                              : "Apply"}
                          </button>
                          <button
                            className="btn-cancel-status"
                            onClick={this.handleCloseStatusFilter.bind(this)}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.cancel
                              : "Cancel"}
                          </button>
                        </div>
                      </div>
                    );
                  },
                  filterDropdownVisible: this.state.filterShipmentStatus,
                  onFilterDropdownVisibleChange: (visible) =>
                    this.setState({ filterShipmentStatus: visible }),
                  filterIcon: (filtered) => (
                    <span
                      style={{ color: filtered ? "#1890ff" : undefined }}
                    ></span>
                  ),
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.partner
                      : "Partner",
                  dataIndex: "courierPartner",
                  className:
                    "camp-status-header camp-status-header-statusFilter table-coloum-hide order-status-header partner-shipment-header",
                  width: 150,
                  filterDropdown: (data, row) => {
                    return (
                      <div className="campaign-status-drpdwn">
                        <ul>
                          {this.state.PartnerFilterData !== null &&
                            this.state.PartnerFilterData.map((item, p) => {
                              return (
                                <li key={p}>
                                  <input
                                    type="checkbox"
                                    id={"New" + item}
                                    className="ch1"
                                    onChange={this.handleCheckPartnerOnchange.bind(
                                      this
                                    )}
                                    name="ShipmentPartner"
                                    attrIds={item}
                                  />
                                  <label htmlFor={"New" + item}>
                                    <span className="ch1-text">{item}</span>
                                  </label>
                                </li>
                              );
                            })}
                        </ul>
                        <div className="dv-status">
                          <button
                            className="btn-apply-status"
                            onClick={this.handleGetShipmentTabGridData.bind(
                              this,
                              "filter"
                            )}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.apply
                              : "Apply"}
                          </button>
                          <button
                            className="btn-cancel-status"
                            onClick={this.handleClosePartnerFilter.bind(this)}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.cancel
                              : "Cancel"}
                          </button>
                        </div>
                      </div>
                    );
                  },
                  filterDropdownVisible: this.state.filterShipmentPartner,
                  onFilterDropdownVisibleChange: (visible) =>
                    this.setState({ filterShipmentPartner: visible }),
                  filterIcon: (filtered) => (
                    <span
                      style={{ color: filtered ? "#1890ff" : undefined }}
                    ></span>
                  ),
                },
                {
                  title:
                    TranslationContext !== undefined
                      ? TranslationContext.title.actions
                      : "Action",
                  className: "action-w",
                  render: (row, item) => {
                    return (
                      <div>
                        <div className="pickuppendingcustom pickup">
                          {item.actionTypeName === "Pickup Pending" ? (
                            <>
                              <Popconfirm
                                title={
                                  <div className="pickuppending-table">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>
                                              {TranslationContext !== undefined
                                                ? TranslationContext.label
                                                    .pickupdate
                                                : "Pickup Date"}
                                              :
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.pickupDate}
                                              disabled={true}
                                            />
                                          </td>
                                          <td>
                                            <label>
                                              {TranslationContext !== undefined
                                                ? TranslationContext.label
                                                    .pickuptime
                                                : "Pickup Time"}
                                              :
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={item.pickupTime}
                                              disabled={true}
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>
                                              {TranslationContext !== undefined
                                                ? TranslationContext.label
                                                    .pickupdone
                                                : "Pickup Done"}
                                            </label>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                }
                                overlayClassName="order-popover order-popover-butns popbtn"
                                placement="bottomRight"
                                onVisibleChange={(visible) =>
                                  this.setState({
                                    orderPopoverOverlay: visible,
                                  })
                                }
                                icon={false}
                                okText={
                                  TranslationContext !== undefined
                                    ? TranslationContext.button.yes
                                    : "Yes"
                                }
                                onConfirm={this.handleUpdateDateandTime.bind(
                                  this,
                                  item.id
                                )}
                                cancelText={
                                  TranslationContext !== undefined
                                    ? TranslationContext.button.no
                                    : "No"
                                }
                              >
                                <button
                                  className={
                                    item.actionTypeName === "Pickup Pending"
                                      ? "butn order-grid-butn order-grid-butn-green"
                                      : "butn order-grid-butn"
                                  }
                                >
                                  {TranslationContext !== undefined
                                    ? TranslationContext.button.pickuppending
                                    : item.actionTypeName}
                                </button>
                              </Popconfirm>
                            </>
                          ) : null}
                          {item.actionTypeName === "Create Shipment" ? (
                            <>
                              <button
                                className={
                                  item.actionTypeName === "Create Shipment"
                                    ? "butn order-grid-butn"
                                    : "butn order-grid-butn order-grid-butn-green"
                                }
                                type="button"
                                onClick={this.handleGetOrderItemDataByOrderId.bind(
                                  this,
                                  item.id,
                                  item.deliveryTypeName
                                )}
                              >
                                {TranslationContext !== undefined
                                  ? TranslationContext.button.createshipment
                                  : item.actionTypeName}
                              </button>
                            </>
                          ) : null}
                          {item.actionTypeName === "Shipment Created" ? (
                            <>
                              <button
                                className={
                                  item.actionTypeName === "Shipment Created"
                                    ? "butn order-grid-butn delibutn"
                                    : "butn order-grid-butn order-grid-butn-green"
                                }
                                type="button"
                                onClick={this.handleGetAWBInvoiceDetailsOrderId.bind(
                                  this,
                                  item.id
                                )}
                              >
                                {TranslationContext !== undefined
                                  ? TranslationContext.button.shipmentcreated
                                  : item.actionTypeName}
                              </button>
                              {item.cancelButtonInShipment && (
                                <Popconfirm
                                  title={
                                    <>
                                      <div className="popover-input-cntr">
                                        <div>
                                          <p>
                                            {TranslationContext !== undefined
                                              ? TranslationContext.p.comment
                                              : "Comment"}
                                          </p>
                                          <textarea
                                            placeholder={
                                              TranslationContext !== undefined
                                                ? TranslationContext.placeholder
                                                    .entercomment
                                                : "Enter Comment"
                                            }
                                            value={this.state.ShipCancelComment}
                                            name="ShipCancelComment"
                                            onChange={(e) =>
                                              this.setState({
                                                ShipCancelComment:
                                                  e.target.value,
                                              })
                                            }
                                          ></textarea>
                                        </div>
                                      </div>
                                    </>
                                  }
                                  overlayClassName="order-popover order-popover-butns shopping-popover-delete"
                                  placement="bottomRight"
                                  onVisibleChange={(visible) =>
                                    this.setState({
                                      orderPopoverOverlay: visible,
                                      ShipCancelComment: "",
                                    })
                                  }
                                  icon={false}
                                  okText="Remove"
                                  onConfirm={this.handleCancleAndCommnetShipment.bind(
                                    this,
                                    item.id
                                  )}
                                >
                                  <button className="butn order-grid-butn order-del-butn">
                                    <img src={OrderDel} alt="delete icon" />
                                  </button>
                                </Popconfirm>
                              )}
                            </>
                          ) : null}
                        </div>
                        <div className="itemviewmobile">
                          <div className="d-flex align-items-center">
                            <p>{item.ordersItemList.length}</p>
                            <Popover
                              content={
                                <Table
                                  className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table"
                                  columns={[
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemid
                                          : "Item ID",
                                      dataIndex: "itemID",
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemname
                                          : "Item Name",
                                      dataIndex: "itemName",
                                      width: 150,
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.itemprice
                                          : "Item Price",
                                      dataIndex: "itemPrice",
                                    },
                                    {
                                      title:
                                        TranslationContext !== undefined
                                          ? TranslationContext.title.quantity
                                          : "Quantity",
                                      dataIndex: "quantity",
                                    },
                                  ]}
                                  scroll={{ y: 240 }}
                                  pagination={false}
                                  dataSource={item.ordersItemList}
                                />
                              }
                              trigger="click"
                              overlayClassName="order-popover-table order-popover order-popover-table-big"
                              onVisibleChange={(visible) =>
                                this.setState({ orderPopoverOverlay: visible })
                              }
                            >
                              <img src={Info} className="item-img" />
                            </Popover>
                          </div>
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              pagination={false}
              showSizeChanger={false}
              onShowSizeChange={false}
              dataSource={this.state.ShipmentGridData}
              loading={this.state.ShipmentLoading}
            />
          ) : (
            <>
              <Pagination
                currentPage={this.state.currentPage}
                totalSize={this.state.totalCount}
                sizePerPage={this.state.postsPerPage}
                changeCurrentPage={this.PaginationOnChange}
                theme="bootstrap"
              />
              <div className="position-relative">
                <div className="item-selection Camp-pagination">
                  <Select
                    value={this.state.postsPerPage}
                    onChange={this.handlePageItemchange}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                  <p>
                    {TranslationContext !== undefined
                      ? TranslationContext.p.itemsperpage
                      : "Items per page"}
                  </p>
                </div>
              </div>
              <Spin spinning={this.state.ShipmentLoading}>
                <Collapse
                  bordered={false}
                  className="site-collapse-custom-collapse"
                  expandIconPosition={"right"}
                  destroyInactivePanel={true}
                  onChange={this.handlecollapseChange.bind(this)}
                  activeKey={this.state.activePanel}
                >
                  {this.state.ShipmentGridData.length > 0
                    ? this.state.ShipmentGridData.map((item, key) => {
                        return (
                          <Panel
                            header={
                              <div>
                                <div>
                                  <div className="d-flex align-items-center overflow-hidden namenumbermain">
                                    <p className="order-bill-no">
                                      {item.invoiceNo}
                                    </p>
                                    {item.ordersItemList.length > 0 ? (
                                      <>
                                        <Popover
                                          content={
                                            <Table
                                              className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table"
                                              columns={[
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemid
                                                      : "Item ID",
                                                  dataIndex: "itemID",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemname
                                                      : "Item Name",
                                                  dataIndex: "itemName",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemprice
                                                      : "Item Price",
                                                  dataIndex: "itemPrice",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .quantity
                                                      : "Quantity",
                                                  dataIndex: "quantity",
                                                },
                                              ]}
                                              scroll={{ y: 240 }}
                                              pagination={false}
                                              dataSource={item.ordersItemList}
                                            />
                                          }
                                          trigger="click"
                                          placement="bottom"
                                          overlayClassName="order-popover-table order-popover order-popover-table-big"
                                          onVisibleChange={(visible) =>
                                            this.setState({
                                              orderPopoverOverlay: visible,
                                            })
                                          }
                                        >
                                          <div className="mobeye">
                                            <img
                                              src={Info}
                                              className="item-img"
                                            />
                                            <span>
                                              {item.ordersItemList.length}
                                            </span>
                                          </div>
                                        </Popover>
                                      </>
                                    ) : null}

                                    {item.isShoppingBagConverted === true && (
                                      <Popover
                                        content={
                                          <>
                                            <p className="shopping-num-invoice">
                                              {TranslationContext !== undefined
                                                ? TranslationContext.title
                                                    .shoppingbagno
                                                : "Shopping bag No"}
                                              :<span>{item.shoppingBagNo}</span>
                                            </p>
                                            <Table
                                              className="components-table-demo-nested antd-table-campaign antd-table-order custom-antd-table"
                                              columns={[
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemid
                                                      : "Item ID",
                                                  dataIndex: "itemID",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemname
                                                      : "Item Name",
                                                  dataIndex: "itemName",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .itemprice
                                                      : "Item Price",
                                                  dataIndex: "itemPrice",
                                                },
                                                {
                                                  title:
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.title
                                                          .quantity
                                                      : "Quantity",
                                                  dataIndex: "quantity",
                                                },
                                              ]}
                                              scroll={{ y: 240 }}
                                              pagination={false}
                                              dataSource={
                                                item.shoppingBagItemList
                                                  .length > 0
                                                  ? item.shoppingBagItemList
                                                  : []
                                              }
                                            />
                                          </>
                                        }
                                        trigger="click"
                                        overlayClassName="order-popover-table order-popover order-popover-invoice"
                                        placement="bottomLeft"
                                        onVisibleChange={(visible) =>
                                          this.setState({
                                            orderPopoverOverlay: visible,
                                          })
                                        }
                                      >
                                        <img
                                          src={OrderInfo}
                                          className="order-info"
                                        />
                                      </Popover>
                                    )}
                                    <div className="namenumber">
                                      <p>{item.customerName},</p>
                                      <p className="order-small-font">
                                        {this.state.isNumberMasking === true &&
                                        this.state.tenantMobileMasking ===
                                          true ? (
                                          <p className="num">
                                            {handleMaskingNumber(
                                              item.mobileNumber,
                                              this.state.maskingPrefix,
                                              this.state.maskingSufix
                                            )}
                                          </p>
                                        ) : (
                                          <p className="num stop_copying">
                                            {item.mobileNumber}
                                          </p>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          >
                            <div className="row">
                              <div className="col-7 p-0">
                                <span className="date">
                                  Partner: &nbsp;
                                  <span>{item.courierPartner}</span>
                                </span>
                              </div>
                              <div className="col-5 p-0 text-right">
                                <span className="stname">
                                  {item.statusName}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 p-0">
                                <span className="delivery">
                                  <img
                                    src={Deliver}
                                    alt="Delivery"
                                    className="delivery"
                                    width="20px"
                                  />
                                  {item.deliveryTypeName}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 p-0">
                                <span className="addres">
                                  <p>{item.shippingAddress}</p>
                                </span>
                              </div>
                              <div className="col-6 pr-1 text-right">
                                {item.actionTypeName === "Pickup Pending" ? (
                                  <>
                                    <Popconfirm
                                      title={
                                        <div className="pickuppending-table">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <label>
                                                    {TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.label
                                                          .pickupdate
                                                      : "Pickup Date"}
                                                    :
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.pickupDate}
                                                    disabled={true}
                                                  />
                                                </td>
                                                <td>
                                                  <label>
                                                    {TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.label
                                                          .pickuptime
                                                      : "Pickup Time"}
                                                    :
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.pickupTime}
                                                    disabled={true}
                                                  />
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <label>
                                                    {TranslationContext !==
                                                    undefined
                                                      ? TranslationContext.label
                                                          .pickupdone
                                                      : "Pickup Done"}
                                                  </label>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      }
                                      overlayClassName="order-popover order-popover-butns popbtn"
                                      placement="bottomRight"
                                      onVisibleChange={(visible) =>
                                        this.setState({
                                          orderPopoverOverlay: visible,
                                        })
                                      }
                                      icon={false}
                                      okText={
                                        TranslationContext !== undefined
                                          ? TranslationContext.button.yes
                                          : "Yes"
                                      }
                                      onConfirm={this.handleUpdateDateandTime.bind(
                                        this,
                                        item.id
                                      )}
                                      cancelText={
                                        TranslationContext !== undefined
                                          ? TranslationContext.button.no
                                          : "No"
                                      }
                                    >
                                      <button
                                        className={
                                          item.actionTypeName ===
                                          "Pickup Pending"
                                            ? "butn order-grid-butn order-grid-butn-green"
                                            : "butn order-grid-butn"
                                        }
                                      >
                                        {TranslationContext !== undefined
                                          ? TranslationContext.button
                                              .pickuppending
                                          : item.actionTypeName}
                                      </button>
                                    </Popconfirm>
                                  </>
                                ) : null}
                                {item.actionTypeName === "Create Shipment" ? (
                                  <>
                                    <button
                                      className={
                                        item.actionTypeName ===
                                        "Create Shipment"
                                          ? "butn order-grid-butn"
                                          : "butn order-grid-butn order-grid-butn-green"
                                      }
                                      type="button"
                                      onClick={this.handleGetOrderItemDataByOrderId.bind(
                                        this,
                                        item.id
                                      )}
                                    >
                                      {TranslationContext !== undefined
                                        ? TranslationContext.button
                                            .createshipment
                                        : item.actionTypeName}
                                    </button>
                                  </>
                                ) : null}
                                {item.actionTypeName === "Shipment Created" ? (
                                  <>
                                    <button
                                      className={
                                        item.actionTypeName ===
                                        "Shipment Created"
                                          ? "butn order-grid-butn delibutn"
                                          : "butn order-grid-butn order-grid-butn-green"
                                      }
                                      type="button"
                                      onClick={this.handleGetAWBInvoiceDetailsOrderId.bind(
                                        this,
                                        item.id
                                      )}
                                    >
                                      {TranslationContext !== undefined
                                        ? TranslationContext.button
                                            .shipmentcreated
                                        : item.actionTypeName}
                                    </button>
                                    {item.cancelButtonInShipment && (
                                      <Popconfirm
                                        title={
                                          <>
                                            <div className="popover-input-cntr">
                                              <div>
                                                <p>
                                                  {TranslationContext !==
                                                  undefined
                                                    ? TranslationContext.p
                                                        .comment
                                                    : "Comment"}
                                                </p>
                                                <textarea
                                                  placeholder={
                                                    TranslationContext !==
                                                    undefined
                                                      ? TranslationContext
                                                          .placeholder
                                                          .entercomment
                                                      : "Enter Comment"
                                                  }
                                                  value={
                                                    this.state.ShipCancelComment
                                                  }
                                                  name="ShipCancelComment"
                                                  onChange={(e) =>
                                                    this.setState({
                                                      ShipCancelComment:
                                                        e.target.value,
                                                    })
                                                  }
                                                ></textarea>
                                              </div>
                                            </div>
                                          </>
                                        }
                                        overlayClassName="order-popover order-popover-butns shopping-popover-delete"
                                        placement="bottomRight"
                                        icon={false}
                                        okText="Remove"
                                        onConfirm={this.handleCancleAndCommnetShipment.bind(
                                          this,
                                          item.id
                                        )}
                                      >
                                        <button className="butn order-grid-butn order-del-butn">
                                          <img
                                            src={OrderDel}
                                            alt="delete icon"
                                          />
                                        </button>
                                      </Popconfirm>
                                    )}
                                  </>
                                ) : null}
                              </div>
                            </div>
                            <div className=""></div>
                          </Panel>
                        );
                      })
                    : null}
                </Collapse>
                {this.state.ShipmentGridData.length === 0 ? (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                ) : null}
              </Spin>
            </>
          )}
          {!this.state.isMobileView ? (
            <>
              <Pagination
                currentPage={this.state.currentPage}
                totalSize={this.state.totalCount}
                sizePerPage={this.state.postsPerPage}
                changeCurrentPage={this.PaginationOnChange}
                theme="bootstrap"
              />
              <div className="position-relative">
                <div className="item-selection Camp-pagination">
                  <Select
                    value={this.state.postsPerPage}
                    onChange={this.handlePageItemchange}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                  <p>
                    {TranslationContext !== undefined
                      ? TranslationContext.p.itemsperpage
                      : "Items per page"}
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <Modal
            open={this.state.ShipmentMdlbtn}
            onClose={this.handleShipmentModalClose.bind(this)}
            center
            modalId="article-popup"
            overlayId="logout-ovrly"
            classNames={{ modal: "ShoimentMobile" }}
          >
            <div
              className="closemob"
              style={{ marginBottom: "20px" }}
              onClick={this.handleShipmentModalClose.bind(this)}
            ></div>
            <div style={{display:'block',width:'100%'}}>
              <img
                src={CancelImg}
                alt="cancelImg"
                className="cancalImg"
                onClick={this.handleShipmentModalClose.bind(this)}
              />
              <div className="step-progress no-focus">
                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item">
                    <a
                      className={
                        this.state.createdShoppingTabs
                          ? "nav-link nav-line disabled-link"
                          : "nav-link nav-line active disabled-link"
                      }
                      data-toggle="tab"
                      href="#article-Map-tab"
                      role="tab"
                      aria-controls="article-Map-tab"
                      aria-selected="true"
                    >
                      <input
                        type="checkbox"
                        className="arti-check"
                        checked={true}
                      />
                      {TranslationContext !== undefined
                        ? TranslationContext.checkbox.articlemapping
                        : "Article Mapping"}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={
                        this.state.createdShoppingTabs
                          ? "nav-link active disabled-link"
                          : "nav-link  active disabled-link"
                      }
                      data-toggle="tab"
                      href="#airwayBill-tab"
                      role="tab"
                      aria-controls="airwayBill-tab"
                      aria-selected="false"
                    >
                      <input
                        type="checkbox"
                        className="arti-check"
                        checked={this.state.createdShoppingTabs}
                      />
                      {TranslationContext !== undefined
                        ? TranslationContext.checkbox.AirwayBillNo
                        : "Airway Bill No"}
                    </a>
                  </li>
                </ul>

                <div className="tab-content store-task-tab-cont orders-tab-cont">
                  <div
                    className={
                      this.state.airWayBill2ndTab
                        ? "tab-pane fade"
                        : this.state.createdShoppingTabs
                        ? "tab-pane fade"
                        : "tab-pane fade show active"
                    }
                    id="article-Map-tab"
                    role="tabpanel"
                    aria-labelledby="article-Map-tab"
                  >
                    <Spin
                      tip={
                        TranslationContext !== undefined
                          ? TranslationContext.tip.pleasewait
                          : "Please wait..."
                      }
                      spinning={this.state.createShipmetLoader}
                    >
                      <div className="tabs-content">
                        <div className="article-body">
                          <span style={{ marginBottom: "30px" }}>
                            {TranslationContext !== undefined
                              ? TranslationContext.span
                                  .itemidshownbelowmappedtothisorder
                              : "Item id shown below mapped to this Order"}
                            &nbsp;<b> {this.state.ShipmentOrderId}</b>&nbsp;
                            {TranslationContext !== undefined
                              ? TranslationContext.span.only
                              : "only."}
                            <br />
                          </span>
                          <div className="table-responsive shipment_div">
                            <Table
                              className="components-table-demo-nested shipment-table-popup antd-table-campaign antd-table-order custom-antd-table order-popover-table table-responsive"
                              columns={[
                                {
                                  title:
                                    TranslationContext !== undefined
                                      ? TranslationContext.title.itemid
                                      : "Article No",
                                  dataIndex: "itemID",
                                  render: (row, item) => {
                                    return (
                                      <p>
                                        <input
                                          type="checkbox"
                                          checked={item.checked}
                                          id={"New" + item.id}
                                          className="ch1"
                                          // onChange={this.handleCheckCreateShipment.bind(
                                          //   this
                                          // )}
                                          onChange={this.handleCheckArticleNo.bind(
                                            this,
                                            item.id
                                          )}
                                          name="CreateShipment"
                                          attrIds={item.id}
                                          disabled={item.disable}
                                          // disabled={this.state.disabledCheckbox}
                                        />
                                        &nbsp;
                                        <Tooltip
                                          title={item.itemID}
                                          placement="bottom"
                                        >
                                          <p className="order-bill-no">
                                            {item.itemID.length > 10
                                              ? item.itemID
                                                  .substr(0, 10)
                                                  .concat("...")
                                              : item.itemID}
                                          </p>
                                        </Tooltip>
                                      </p>
                                    );
                                  },
                                },
                                {
                                  title:
                                    TranslationContext !== undefined
                                      ? TranslationContext.title.itemname
                                      : "Article Name",
                                  dataIndex: "itemName",
                                  render: (row, item) => {
                                    return (
                                      <p>
                                        <Tooltip
                                          title={item.itemName}
                                          placement="bottom"
                                        >
                                          <p className="order-bill-no">
                                            {item.itemName.length > 12
                                              ? item.itemName
                                                  .substr(0, 12)
                                                  .concat("...")
                                              : item.itemName}
                                          </p>
                                        </Tooltip>
                                      </p>
                                    );
                                  },
                                  width: 150,
                                },
                                {
                                  title:
                                    TranslationContext !== undefined
                                      ? TranslationContext.title.itemprice
                                      : "Article MRP",
                                  dataIndex: "itemPrice",
                                },
                                {
                                  title:
                                    TranslationContext !== undefined
                                      ? TranslationContext.title.itemquantity
                                      : "Article Quantity",
                                  dataIndex: "quantity",
                                },
                                {
                                  title: () => (
                                    <>
                                      {this.state.ShipShowTemplate && (
                                        <select
                                          className="rectangle-9"
                                          name="selectedTemplate"
                                          value={this.state.selectedTemplate}
                                          onChange={this.handleSelectTemplateDD}
                                        >
                                          <option value="0">
                                            {TranslationContext !== undefined
                                              ? TranslationContext
                                                  .ticketingDashboard
                                                  .selecttemplate
                                              : "Select Template"}
                                          </option>
                                          {this.state.TemplateData !== null &&
                                            this.state.TemplateData.map(
                                              (item, j) => {return(
                                                <option key={j} value={item.id}>
                                                  {item.templateName}
                                                </option>
                                              )}
                                            )}
                                        </select>
                                      )}
                                    </>
                                  ),
                                },
                              ]}
                              scroll={{ y: 240 }}
                              pagination={false}
                              dataSource={this.state.ShipmentOrderItem}
                            />
                          </div>
                        </div>
                        <div className="dv-status m-t-20 ship-mar-bot">
                          {this.state.ShowSelectCourierPartner && (
                            <div className="ordDisply">
                              <label>
                                {TranslationContext !== undefined
                                  ? TranslationContext.ticketingDashboard
                                      .selectcourierpartner
                                  : "Select Courier Partner"}
                              </label>
                              <select
                                className="rectangle-9"
                                onChange={(e) =>
                                  this.setState({
                                    selectCourierPartner: e.target.value,
                                  })
                                }
                                value={this.state.selectCourierPartner}
                              >
                                {/* <option value="0">
                                  {TranslationContext !== undefined
                                    ? TranslationContext.ticketingDashboard
                                        .selectpartner
                                    : "Select Partner"}
                                </option> */}
                                <option value="Store">Store</option>
                                <option value="courierpartner">
                                  Courier Partner
                                </option>
                              </select>
                            </div>
                          )}

                          <button
                            className="btn-shipment-popup canshio"
                            style={{ marginRight: "10px" }}
                            onClick={this.handleShipmentModalClose.bind(this)}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.cancel
                              : "Cancel"}
                          </button>
                          <button
                            style={{ marginRight: "0px" }}
                            className={
                              this.state.createShipmentBtnDisbaled
                                ? "btnClickDisabled btn-shipment-saveNext"
                                : "btn-shipment-saveNext"
                            }
                            onClick={this.handleCreateShipmentCheck.bind(this)}
                            disabled={this.state.createShipmentBtnDisbaled}
                          >
                            {TranslationContext !== undefined
                              ? TranslationContext.button.saveandnext
                              : "Save & Next"}
                          </button>
                        </div>
                      </div>
                    </Spin>
                  </div>
                  <div
                    className={
                      this.state.airWayBill2ndTab
                        ? "tab-pane fade show active"
                        : this.state.createdShoppingTabs
                        ? "tab-pane fade show active"
                        : "tab-pane fade"
                    }
                    id="airwayBill-tab"
                    role="tabpanel"
                    aria-labelledby="airwayBill-tab"
                  >
                    <div
                      className="tabs-content shipmentCorrectedCss"
                      style={{
                        width: "750px",
                        maxHeight: "320px",
                        overflow: "scroll",
                      }}
                    >
                      {this.state.ShipmentCreatedData !== null &&
                        this.state.ShipmentCreatedData.map((item, b) => (
                          <div className="text-center airwaybox">
                            <div className="airwaycontent">
                              <img
                                src={CardTick}
                                alt="CardTick"
                                className="cardtick"
                              />
                              <h2>
                                {item.isStoreDelivery ? (
                                  "Courier Partner - Store"
                                ) : (
                                  <>
                                    {TranslationContext !== undefined
                                      ? TranslationContext.title.awbno
                                      : "AWB No"}
                                    - {item.awbNumber}
                                  </>
                                )}
                              </h2>
                              <p className="success">
                                {TranslationContext !== undefined
                                  ? TranslationContext.p.successfullymappedto
                                  : "Successfully mapped to"}
                              </p>
                              <ul className="mobileul">
                                <li className="success1">
                                  {TranslationContext !== undefined
                                    ? TranslationContext.p.successfullymappedto
                                    : "Successfully mapped to"}
                                </li>

                                <li>
                                  {TranslationContext !== undefined
                                    ? TranslationContext.label.orderid
                                    : "Order ID"}
                                  {/* - {this.state.ShipmentOrderId} */}-{" "}
                                  {item.invoiceNo}
                                </li>
                                <li>
                                  {TranslationContext !== undefined
                                    ? TranslationContext.li.itemid
                                    : "Item ID"}
                                  {" - "}
                                  {/* {this.state.AirwayItemIds} */}

                                  <Tooltip
                                    title={item.itemIDs}
                                    placement="bottom"
                                  >
                                    <p className="shipItemtlTp">
                                      {item.itemIDs.length > 20
                                        ? item.itemIDs
                                            .substr(0, 20)
                                            .concat("...")
                                        : item.itemIDs}
                                    </p>
                                  </Tooltip>
                                </li>
                              </ul>

                              {item.showShipmentCharges ? (
                                <p style={{ color: "black" }}>
                                  {TranslationContext !== undefined
                                    ? TranslationContext.ticketingDashboard
                                        .shipmentcharges
                                    : "Shipment Charges "}
                                  : {item.shipmentCharges}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        ))}
                    </div>
                    <div className="dv-status m-t-20 ship-mar-bot">
                      <button
                        className="btn-shipment-popup canshio"
                        style={{ marginRight: "10px" }}
                        onClick={this.handleShipmentModalClose.bind(this)}
                      >
                        {TranslationContext !== undefined
                          ? TranslationContext.button.cancel
                          : "Cancel"}
                      </button>
                      <button
                        style={{ marginRight: "0px" }}
                        className="btn-shipment-saveNext"
                        onClick={this.handleShipmentModalClose.bind(this)}
                      >
                        {TranslationContext !== undefined
                          ? TranslationContext.button.done
                          : "Done"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

export default ShipmentTab;
